// extracted by mini-css-extract-plugin
module.exports = {"tags_head_container":"style_tags_head_container__rr80u","section":"style_section__gCWkm"};